if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      // Retrieve the rotation seconds from the corresponding attribute. If defined, enable auto-rotation and parse the value.
      const rotationAttr = this.dataset.rotationSeconds;
      this.autoRotate = rotationAttr !== undefined;
      this.rotationSeconds = this.autoRotate ? parseInt(rotationAttr, 10) : 0;

      this.index = 0;
      this.length = this.content.length;
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
          // Reset rotation if a user changes slides manually  
          if (this.autoRotate) this.resetRotation();  
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
          if(this.autoRotate) this.resetRotation();  
        });
      }
      if(this.autoRotate) this.startRotation();
      
    }


    // Start rotation by invoking the changeSlide("next") function with the second argument set to true. The latter ensures that when a user manually reaches the last slide, it doesn't loop back to the first notification.

    startRotation() {
      if(this.rotationInterval) clearInterval(this.rotationInterval);

      this.rotationInterval = setInterval(() => {
          this.changeSlide('next', true);  
      }, this.rotationSeconds * 1000);
    }
    
    resetRotation() {
      this.startRotation();
    }

    changeSlide(direction, isAutoRotation = false) {

      this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        // / If currently on the last notification and the changeSlide("next") is invoked by auto-rotation, loop back to the first notification. 
        if(this.index === this.length - 1 && isAutoRotation) {
          this.index = 0;
        } else {
          this.index++;
        } 
      } else if ( direction == 'prev' ) {
        this.index--;
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled')
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled')
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}